// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__kHI1m","consentsList":"PatientConsents_consentsList__CQKkA","consentsListEmpty":"PatientConsents_consentsListEmpty__3PebJ"};